import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';
import { yesOrNot } from 'helpers';
import { TFunc } from 'libs/i18n';

import { CompanyGlobalFinancialMonitoringPartOneFormType } from '../../forms/companyGlobalFinancialMonitoringPartOneForm';

export const getInitialData = (
  t: TFunc,
  data?: LegalClientFinancialMonitoringEntity
): CompanyGlobalFinancialMonitoringPartOneFormType =>
  // if (!data) {
  //   return {
  //     mandatoryAmlRegulation: {
  //       hasMandatoryAmlRegulations: {},
  //     },
  //   } as CompanyGlobalFinancialMonitoringPartOneFormType;
  // }

  ({
    isSubjectToRegulation: yesOrNot(t, data?.isSubjectToRegulation),
    supervisoryAuthorityNameAndLocation:
      data?.globalInfo?.partOne?.supervisoryAuthorityNameAndLocation,
    mandatoryAmlRegulation: {
      hasMandatoryAmlRegulations: yesOrNot(
        t,
        data?.globalInfo?.partOne?.mandatoryAmlRegulation
          .hasMandatoryAmlRegulations
      ),
      regulationDetails:
        data?.globalInfo?.partOne?.mandatoryAmlRegulation.regulationDetails,
      authorizedBodyName:
        data?.globalInfo?.partOne?.mandatoryAmlRegulation.authorizedBodyName,
    },
    lastAmlAuditResult: data?.globalInfo?.partOne?.lastAmlAuditResult,
    investigationsOrSanctions: {
      hadInvestigationsOrSanctions: yesOrNot(
        t,
        data?.globalInfo?.partOne?.investigationsOrSanctions
          .hadInvestigationsOrSanctions
      ),
      amlDecisionDateAndAuthorityInfo:
        data?.globalInfo?.partOne?.investigationsOrSanctions
          .amlDecisionDateAndAuthorityInfo,
    },
    internalAmlDocuments: {
      hasInternalAmlDocuments: yesOrNot(
        t,
        data?.globalInfo?.partOne?.internalAmlDocuments.hasInternalAmlDocuments
      ),
      adoptionDate:
        data?.globalInfo?.partOne?.internalAmlDocuments.adoptionDate,
      lastUpdateDate:
        data?.globalInfo?.partOne?.internalAmlDocuments.lastUpdateDate,
      hasEffectivenessAssessmentProcedures: yesOrNot(
        t,
        data?.globalInfo?.partOne?.internalAmlDocuments
          .hasEffectivenessAssessmentProcedures
      ),
      lastEffectivenessCheckInfo:
        data?.globalInfo?.partOne?.internalAmlDocuments
          .lastEffectivenessCheckInfo,
      appliesToForeignAffiliates: yesOrNot(
        t,
        data?.globalInfo?.partOne?.internalAmlDocuments
          .appliesToForeignAffiliates
      ),
    },
    departmentsResponsibleForAmlFunctions: {
      hasDepartmentsResponsibleForAmlFunctions: yesOrNot(
        t,
        data?.globalInfo?.partOne?.departmentsResponsibleForAmlFunctions
          .hasDepartmentsResponsibleForAmlFunctions
      ),
      amlFunctionDepartmentsNames:
        data?.globalInfo?.partOne?.departmentsResponsibleForAmlFunctions
          .amlFunctionDepartmentsNames,
    },
    responsibleAmlManager: {
      hasResponsibleAmlManager: yesOrNot(
        t,
        data?.globalInfo?.partOne?.responsibleAmlManager
          .hasResponsibleAmlManager
      ),
      fullName: data?.globalInfo?.partOne?.responsibleAmlManager.fullName,
      position: data?.globalInfo?.partOne?.responsibleAmlManager.position,
      email: data?.globalInfo?.partOne?.responsibleAmlManager.email,
      phoneNumber: data?.globalInfo?.partOne?.responsibleAmlManager.phoneNumber,
    },
    hasRiskManagementProcedures: yesOrNot(
      t,
      data?.globalInfo?.partOne?.hasRiskManagementProcedures
    ),
  });
